module.exports = __webpack_public_path__ + "img/HTML.c623f863.svg";